var service = {};

if (process.env.NODE_ENV === 'production') {
    service.API_URL = 'https://vm-api.oterri.com';
} else {
    service.API_URL = 'http://192.168.1.91:5005';
}

export default service;
